module.exports = __webpack_public_path__ + "static/media/nBywdu9GUx.de8f90ab.jpg";